var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3555 1.84961C12.1023 1.84965 12.8185 2.14677 13.3467 2.6748C13.8749 3.20303 14.1719 3.91997 14.1719 4.66699V11.5811C14.1719 12.3281 13.8749 13.045 13.3467 13.5732C12.8185 14.1013 12.1023 14.3984 11.3555 14.3984H4.66699C3.91998 14.3984 3.20303 14.1015 2.6748 13.5732C2.14658 13.045 1.84961 12.3281 1.84961 11.5811V4.66699C1.84961 3.91997 2.14658 3.20303 2.6748 2.6748C3.20303 2.14658 3.91997 1.84961 4.66699 1.84961H11.3555ZM4.66699 3.15039C4.26475 3.15039 3.87818 3.30932 3.59375 3.59375C3.30932 3.87818 3.15039 4.26475 3.15039 4.66699V11.5811C3.15039 11.9831 3.30961 12.3689 3.59375 12.6533C3.87818 12.9378 4.26475 13.0977 4.66699 13.0977H11.3555C11.7577 13.0976 12.1433 12.9377 12.4277 12.6533C12.712 12.3689 12.8721 11.9832 12.8721 11.5811V4.66699C12.8721 4.26475 12.7122 3.87818 12.4277 3.59375C12.1434 3.30951 11.7575 3.15043 11.3555 3.15039H4.66699Z",
    fill: "currentFill",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.80005,
    y: 9.66669,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "currentFill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80005 6.66667C4.80005 6.48986 4.87029 6.32029 4.99531 6.19526C5.12034 6.07024 5.2899 6 5.46672 6H10.8C10.9769 6 11.1464 6.07024 11.2715 6.19526C11.3965 6.32029 11.4667 6.48986 11.4667 6.66667C11.4667 6.84348 11.3965 7.01305 11.2715 7.13807C11.1464 7.2631 10.9769 7.33333 10.8 7.33333H5.46672C5.2899 7.33333 5.12034 7.2631 4.99531 7.13807C4.87029 7.01305 4.80005 6.84348 4.80005 6.66667ZM6.80005 10C6.80005 9.82319 6.87029 9.65362 6.99531 9.5286C7.12034 9.40357 7.2899 9.33333 7.46672 9.33333H10.8C10.9769 9.33333 11.1464 9.40357 11.2715 9.5286C11.3965 9.65362 11.4667 9.82319 11.4667 10C11.4667 10.1768 11.3965 10.3464 11.2715 10.4714C11.1464 10.5964 10.9769 10.6667 10.8 10.6667H7.46672C7.2899 10.6667 7.12034 10.5964 6.99531 10.4714C6.87029 10.3464 6.80005 10.1768 6.80005 10Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIcon);
export default __webpack_public_path__ + "static/media/CategoryIcon.45e698551e73d50621d9ae14f1659619.svg";
export { ForwardRef as ReactComponent };